import logo from 'assets/icons/logo.png';

// Shared Clerk appearance, used by every sign-in / sign-up card in the product:
// the customer auth pages (modules/Auth) and the admin console's own SignIn
// (modules/Admin/components/AdminRoot.jsx).
//
// It lives in Common/config rather than in Auth because it is a pure
// (brand) => appearanceObject with no Auth coupling — its only import is the
// fallback logo — and because the admin console is a SEPARATE build target whose
// isolation gate rejects an Admin -> Auth edge (admin-dashboard phase 3 §4).
// Whitelabel branding has to reach both apps or an Ayming admin gets a generic
// Clerk card in front of a branded console.
//
// The card carries the logo itself (logoPlacement 'inside') because brand logos
// are drawn for light backgrounds: on the customer side AuthShell's backdrop is
// the dark brand panel on every breakpoint, and the card is the only
// guaranteed-light surface. The card keeps Clerk's step-aware header copy below
// it. On the admin side the surrounding page is already light, so the same
// setting simply reads as a logo on a white card.
export const buildClerkAppearance = (brand) => ({
  variables: {
    colorPrimary: brand.primaryColor,
    borderRadius: '0.625rem',
  },
  layout: {
    logoPlacement: 'inside',
    logoImageUrl: brand.logoUrl || logo,
  },
  elements: {
    rootBox: 'w-full flex justify-center',
    // Explicit white: cardBox is transparent by default, and Clerk's footer
    // (sign-up prompt) renders inside it — on the dark AuthShell backdrop its
    // muted text would otherwise lose contrast.
    cardBox: '!shadow-none !rounded-2xl !bg-white w-full max-w-[420px]',
    logoImage: '!h-8',
  },
});
